import styles from 'assets/css/BarChartStyle.module.css';

export const PointInRangeChart = (props) => {
    const { emptyRow, lowGlucoseWidth, inRangeGlucoseWidth, highGlucoseWidth } = props;
    return (
        <div className={`${styles.pointInRangeContainer} ${emptyRow && styles.emptyPointInRange}`}>
            <div
                style={{
                    width: isNaN(lowGlucoseWidth) ? 0 : lowGlucoseWidth + '%',
                    background: 'linear-gradient(165deg, #ea79a0 23%, #d81d5d 79%)',
                }}
                className={styles.pointInRange}
            />
            <div
                style={{
                    width: isNaN(inRangeGlucoseWidth) ? 0 : inRangeGlucoseWidth + '%',
                    background: 'linear-gradient(165deg, #5bf16f 23%, #3bba4c 79%)',
                }}
                className={styles.pointInRange}
            />
            <div
                style={{
                    width: isNaN(highGlucoseWidth) ? 0 : highGlucoseWidth + '%',
                    background: ' linear-gradient(149deg, #fbc87c 22%, #fcb347 79%)',
                }}
                className={styles.pointInRange}
            />
        </div>
    );
};